const reducer = (key, value) => {
    switch (key) {
        case 'name':
            if (typeof value !== 'string' || (typeof value === 'string' && value.length < 3)) return `At least three characters`
            break
        case 'slug':
            if (typeof value !== 'string' || (typeof value === 'string' && value.length < 3)) return `At least three characters`
            break
        case 'url':
            if (typeof value !== 'string' || value.length > 100 || value.length < 1) return `It must be a character string with a maximun of 100 characters`
            break
        case 'synced':
            if (typeof value !== 'number' && (value === 0 || value === 1)) return `Must be 0 or 1`
            break
        default:
            return null
    }
}

const validate = (values) => ({
    ...Object.keys(values).reduce((obj, k) => {
        const out = obj
        const error = reducer(k, values[k])
        if (error) out[k] = error
        return obj
    }, {}),
})

export default validate
